import type { FaireProductEntity } from "../../entity_types/product";

export const toysmith_11: FaireProductEntity = {
  token: "toysmith-11",
  type: "product",
  name: "Beetle & Bee Kid Sized Wheelbarrow, Assorted (Red & Green)",
  brandName: "Toysmith",
  imageUrl:
    "https://cdn.faire.com/fastly/2794355d1cac84eeda36f4d18141b32665cb931e899325007b7ad0d14cba3c60.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=826,825,x50,y0,safe&width=720",
  priceDollars: 22,
  msrpDollars: 44,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-toys"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
